import { useMutation } from 'react-query';
import { replyAdjustmentComment } from 'apis/adjustmentComments.api';

const useReplyAdjustmentComment = () => {
  const { mutateAsync, ...rest } = useMutation(replyAdjustmentComment);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useReplyAdjustmentComment;
